import { BaseTextMergeContainerEditor } from "./Text/BaseTextMergeContainerEditor";
import React from "react";
import { TextEditorRegistration } from "../Utilities/RegisterTextEditor";
import { ObserveState } from "../../CommonUI/StateManagement/ObserveState";
import { ExpressionView } from "../../Expressions/ExpressionView";
import { Box } from "@mui/material";
import { UILabel } from "../../CommonUI/BuildlingBlocks/UILabel";
import { QuestionMark } from "@mui/icons-material";
import { TextMergeEditContext } from "../../rule-engine-core/TextMerge/TextMergeEditContext";
import { BaseTextMergeContainerElement } from "../../rule-engine-core/TextMerge/Elements/BaseTextMergeContainerElement";
import { ConditionalElement } from "../../rule-engine-core/TextMerge/Elements/ConditionalElement";

export class ConditionalElementEditor extends BaseTextMergeContainerEditor<ConditionalElement> {
    renderAbove(_element: BaseTextMergeContainerElement, _context: TextMergeEditContext): JSX.Element | undefined {
        return (
            <Box paddingLeft={"30px"}>
                <UILabel>Output if:</UILabel>
                <ExpressionView expression={this.editorData!.condition}></ExpressionView>
                <hr />
            </Box>
        );
    }

    renderContent(editContext: TextMergeEditContext, _styles: object): React.ReactNode {
        return this.editorData?.elements.map((e) => {
            let editor = TextEditorRegistration.getExpressionByTypeName(e.__type)?.create(e);
            return (
                <ObserveState
                    listenTo={e}
                    control={() => {
                        return editor?.renderDisplay(e, editContext);
                    }}
                />
            );
        });
    }

    getIcon(): JSX.Element {
        return <QuestionMark />;
    }
}
